import React, {FC} from 'react'
import {SvgIconProps} from '@mui/material'
import {blueColor} from '../../../@theme/vars'

export const SimpleFigure: FC<SvgIconProps> = props => {
  return (
    <svg
      {...props}
      width={props.width ?? '27'}
      height={props.height ?? '24'}
      viewBox='0 0 28 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25.0455 0H2.95455C1.72727 0 0.5 1.33333 0.5 2.66667V21.3333C0.5 22.8 1.60455 24 2.95455 24H25.0455C26.2727 24 27.5 22.6667 27.5 21.3333V2.66667C27.5 1.33333 26.2727 0 25.0455 0ZM25.0455 21.2267C25.0209 21.2667 24.9718 21.3067 24.9473 21.3333H2.95455V2.77333L3.05273 2.66667H24.935C24.9718 2.69333 25.0086 2.74667 25.0332 2.77333V21.2267H25.0455ZM12.7727 16.68L9.70455 12.6667L5.40909 18.6667H22.5909L17.0682 10.6667L12.7727 16.68Z'
        fill={props.color === 'primary' ? blueColor : '#C4C4C4'}
      />
    </svg>
  )
}
